import { get, post } from 'lib/API';
import Invite from 'data/Invite';
import { BusinessUnitUserResponse, AdminUserResponse } from 'data/BusinessUnitUser';

export const acceptInvite = async ([invite, password]: any[]): Promise<any> => {
  return await post(`v1/invites/${invite.id}`, undefined, { password });
};

/**
 * Validate invite token (secure flow)
 * @param token - JWT token from invite URL
 */
export const validateInviteToken = async ({ token }: { token: string }): Promise<any> => {
  return await get(`v1/invites/validate`, undefined, { token });
};

/**
 * Complete invite with password (secure flow)
 * @param token - JWT token from invite URL
 * @param password - User's new password
 */
export const completeInvite = async ([token, password]: any[]): Promise<any> => {
  return await post(`v1/invites/complete`, undefined, { token, password });
};

export const createInvite = async (
  [email, name, role, vendorId, ginId]: string[],
  { token }: any
): Promise<any> => {
  return await post('v1/invites', token, { email, name, role, vendorId, ginId });
};

export const loadInvite = async ({ inviteId }: any): Promise<Invite> => {
  return await get(`v1/invites/${inviteId}`);
};

export const loadInvites = async ({ token }: any): Promise<Invite[]> => {
  return await get('v1/invites', token);
};

export const getInvitesV2 = async ([businessUnitId, page, limit, sortBy, sortOrder, vendorId, searchTerm]: any[], { token }: any): Promise<BusinessUnitUserResponse> => {
  return await get('v2/invites', token, { businessUnitId, page, limit, sortBy, sortOrder, vendorId, searchTerm });
};

export const createInviteV2 = async (
  [email, name, role, businessUnitId, ginId, vendorId]: string[],
  { token }: any
): Promise<any> => {
  return await post('v2/invites', token, { email, name, role, businessUnitId, ginId, vendorId });
}

export const getAdminUsers = async ([page, limit, sortBy, sortOrder, searchTerm]: any[], { token }: any): Promise<AdminUserResponse> => {
  return await get('v2/invites/admins', token, { page, limit, sortBy, sortOrder, searchTerm });
};